import Skeleton from "../../ui/Skeleton";
import "./_catalog-card.scss";

/**
 * Loading placeholder for CatalogCard, same glass-panel shell + row rhythm
 * (identity/badge row, price row, description, metric rows) so the gallery
 * grid doesn't jump in size once real cards replace it.
 */
const CatalogCardSkeleton = () => (
  <div className="catalog-card">
    <div className="catalog-card__top">
      <div className="catalog-card__identity">
        <Skeleton width="8px" height="8px" radius="50%" />
        <Skeleton width="120px" height="18px" />
      </div>
      <div className="catalog-card__top-right">
        <Skeleton width="52px" height="22px" radius="8px" />
        <Skeleton width="22px" height="22px" radius="6px" />
      </div>
    </div>

    <div className="catalog-card__price">
      <Skeleton width="88px" height="30px" radius="6px" />
      <Skeleton width="46px" height="14px" />
    </div>

    <div className="catalog-card__desc-skeleton">
      <Skeleton width="100%" height="14px" />
      <Skeleton width="70%" height="14px" />
    </div>

    <div className="catalog-card__divider" />

    <div className="catalog-card__metrics">
      {[0, 1, 2].map((row) => (
        <div className="catalog-card__metric-row" key={row}>
          <Skeleton width="72px" height="12px" />
          <Skeleton width="54px" height="12px" />
        </div>
      ))}
    </div>
  </div>
);

export default CatalogCardSkeleton;
